import { render, staticRenderFns } from "./configurationCustomerProfile.vue?vue&type=template&id=e7f8e67e"
import script from "./configurationCustomerProfile.vue?vue&type=script&lang=js"
export * from "./configurationCustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./configurationCustomerProfile.vue?vue&type=style&index=0&id=e7f8e67e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports